import React from "react"

import ImageSelector from "../../../common/ImageSelector"

const UserEditItemDetails = ({
    first_name,
    last_name,
    status,
    primary_organisation,
    primary_position,
    bio,
    photo_url,
    imagePreviewURL,
    onEventChange,
    onImageChange,
    onStatusChange
}) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <i className="icon icon-headline" />First Name
            </h3>
            <input
                type="text"
                name="first_name"
                className="form-control"
                placeholder="First Name"
                value={first_name}
                onChange={onEventChange}
            />
            <h3>
                <i className="icon icon-headline" />Last Name
            </h3>
            <input
                type="text"
                name="last_name"
                className="form-control"
                placeholder="Last Name"
                value={last_name}
                onChange={onEventChange}
            />
            <h3>
                <i className="icon icon-status" />Status
            </h3>
            <label>
                <input
                    type="checkbox"
                    name="status"
                    checked={status === "Active"}
                    onChange={onStatusChange}
                />{" "}
                Active
            </label>
            <h3>
                <i className="icon icon-user-primary-org" />Primary Organisation
            </h3>
            <input
                name="primary_organisation"
                className="form-control"
                placeholder="Primary Organisation"
                value={primary_organisation}
                onChange={onEventChange}
            />
            <h3>
                <i className="icon icon-user-primary-position" />Primary
                Position
            </h3>
            <input
                name="primary_position"
                className="form-control"
                placeholder="Primary Position"
                value={primary_position}
                onChange={onEventChange}
            />
            <h3>
                <i className="icon icon-description" />Bio
            </h3>
            <textarea
                name="bio"
                className="form-control"
                placeholder="Bio"
                value={bio}
                onChange={onEventChange}
            />
            <h3>
                <i className="icon icon-heroimg" />User Picture
            </h3>
            <ImageSelector
                onImageSelect={onImageChange}
                imageUrl={
                    imagePreviewURL !== undefined ? imagePreviewURL : photo_url
                }
            />
        </div>
    </div>
)

export default UserEditItemDetails
